module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/128.e886df78.svg";